/**
 * Extract the non-null `user` from a list of active group members.
 *
 * Centralises null-handling so callers receive `User[]` (or whatever user shape
 * the query selected) directly.
 */
export function getActiveMemberUsers<T>(
  activeGroupMembers:
    | ReadonlyArray<{ user: T | null }>
    | null
    | undefined
): T[] {
  if (!activeGroupMembers) return [];
  return activeGroupMembers
    .map((m) => m.user)
    .filter((u): u is T => u !== null);
}
